exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.banners[data-v-f39a6e5a] {\n  background: #ff6033;\n  font-size: 16px;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: 0.1px;\n  text-align: center;\n  color: #ffff;\n  padding: 4px 8px;\n}\n.text-banner[data-v-f39a6e5a] {\n  margin-left: 5px;\n  -ms-flex-item-align: center;\n      align-self: center;\n}\n", ""]);

// exports
